// extracted by mini-css-extract-plugin
export default {"title":"J5-z","warning":"K5-z","sizeOptionsLegendText":"L5-z"};